import { useEffect, useState } from "react";

/**
 * Delays updating the value until after `delayMs` of inactivity
 */
export const useDebounce = (
    value,
    delayMs = 500
) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delayMs);

        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debouncedValue;
};
